import { GetterTree } from 'vuex'
import {
  EvaluationInquiryApplication,
  EvaluationInquiryApplicationsState,
} from '@/store/applications/evaluationInquiries/types'
import { RootState } from '@/store/types'

const getters : GetterTree<EvaluationInquiryApplicationsState, RootState> = {
  /**
   * 申請IDを元に評価問い合わせ申請情報を取得
   * @param {string} applicationId 申請ID
   * @return {EvaluationInquiryApplication|null} 申請情報
   */
  findEvaluationInquiryApplicationById:
  (state) => (applicationId: string): EvaluationInquiryApplication|null => {
    return state.applications.find(
      (app: EvaluationInquiryApplication) => app.id === applicationId,
    ) || null
  },
}

export default getters
